import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

import styles from "./styles.module.scss"

const FullScreenSlideout = ({ isMasked, isClosaableMask, isOpen, setIsOpen, isViewClose, title, children }) => {
  
  const _getMask = () => {
    if (isMasked) {
      let classes = styles.slideOut__mask
      if (isOpen) classes += ' ' + styles.slideOut__mask__open
      return (
        <div className={classes} onClick={() => {
          if (isClosaableMask) {
            setIsOpen(false)
          }
        }}></div>
      )
    }
    return null
  }
  
  
  let classes = styles.slideOut
  if (isOpen) classes += ' ' + styles.slideOut__open

  return (
    <>
      <div className={classes}>
        <header>
          <h3>{title}</h3>
          {isViewClose && <button onClick={() => setIsOpen(false)} className={styles.closeButton}><FontAwesomeIcon icon={faTimes} /></button>}
        </header>
        <div>
          {children}
        </div>
      </div>
      {_getMask()}
    </>
  )
}

export default FullScreenSlideout
